import axios, { AxiosRequestConfig } from 'axios';
import config from 'appconfig';

import paramsSerializer from 'util/paramsSerializer';
import { FeatureFlags, checkFeatureGate } from 'util/statsig/index';
import { baseProductApiUrl } from './mac';

const getPadresClient = (clientConfig: AxiosRequestConfig = {}) => {
  const cartHAMSAPIInsteadOfPadres = checkFeatureGate(FeatureFlags.CART_HAMS_API_INSTEAD_OF_PADRES);

  return axios.create({
    baseURL: cartHAMSAPIInsteadOfPadres
      ? `${config.hamsUrl}${baseProductApiUrl}`
      : config.padresUrl,
    maxContentLength: 50000,
    withCredentials: false,
    paramsSerializer,
    ...clientConfig,
  });
};

export default getPadresClient;
